<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div style="display: flex; justify-content: end;">
          <div style="display: flex; align-items: center;">
            <argon-input
                id="searchField"
                placeholder="Поиск"
                v-model="searchText"
                :value="searchText"
                style="margin-right: 10px;"
                @input="setSearchText"
                @keyup.enter="startSearch"
            />
            <SortTemplate  :options="sortOptions"
                           v-model:sortValue="blackListSort"
                           :change-sort-action="setSortType"/>
            <button class="btn btn-primary" @click="startSearch">Искать</button>
          </div>
        </div>
        <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <div v-if="this.isLoading">
            <CircleProgress/>
          </div>
        </transition>
        <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <div v-if="!this.isLoading">
            <Table
                :columns="columns"
                :data="blackList"
                :deleteAction="deleteFromBlackList"
                :tableName="'Черный список'"
            />

            <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
              <button class="btn btn-primary" style="margin-right: 10px;" @click="previousPage" :disabled="blackListPaginationStart <= 0"><i
                  class="ni ni-bold-left"></i></button>
              <button class="btn btn-primary" @click="nextPage" :disabled="blackListSize > blackList.length"><i
                  class="ni ni-bold-right"></i></button>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import CircleProgress from "./components/CircleProgress.vue";
import Table from "./components/Table.vue";
import axios from "@/axios";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import velocity from "velocity-animate";
import SortTemplate from "../components/standart/SortTemplate.vue";
import ArgonInput from "../components/ArgonInput.vue";

export default {
  name: "BlackList",
  components: {
    ArgonInput,
    SortTemplate,
    Table,
    CircleProgress
  },
  data() {
    return {
      blackList: [],
      columns: ['ID',
        'Причина',
        'Имя',
        'Телефон',
      ],
      sortOptions: [
        { key: 'null', value: 'null', text: 'Все' },
        { key: 'ASC', value: 'ASC', text: 'От А до Я' },
        { key: 'DESC', value: 'DESC', text: 'От Я до А' },
      ],
      showModal: false,
    };
  },
  computed: {
    searchText: {
      get() {
        return this.$store.state.blackListSearchText;
      }
    },
    isLoading: {
      get() {
        return this.$store.state.isBlackListLoading;
      },
    },

    blackListSize: {
      get() {
        return this.$store.state.blackListSize
      }
    },
    blackListPaginationStart: {
      get() {
        return this.$store.state.blackListPaginationStart
      }
    },
    blackListSort: {
      get() {
        return this.$store.state.blackListSortType
      }
    }
  },
  methods: {

    fetchData() {
      this.updateBlackListIsLoading(true);
      let url = '/api/clients/get-blacklist?length=' + this.blackListSize + "&start=" + this.blackListPaginationStart;
      if (this.searchText != null && this.searchText.length >= 3) {
        url = '/api/clients/get-blacklist?length='+this.blackListSize + "&search=" + this.searchText;
        this.clearSearchText();
        if(this.blackListPaginationStart != 0) {
          this.resetPagination();
        }
      }
      if (this.blackListSort != null && this.blackListSort != "null") {
        url = url + "&sort=" + this.blackListSort;
      }
      axios.get(url).then(response => {
        let list = response.data.data;
        this.blackList = list;
        this.updateBlackListIsLoading(false);
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
        this.updateBlackListIsLoading(false);
      });
    },
    deleteFromBlackList(item) {
      axios.post(`/api/clients/remove-from-blacklist/${item.client.id}`).then(() => {
        this.fetchData();
      });
    },
    setSortType(sortType) {
      this.$store.commit('updateBlackListSortType', sortType.target.value);
    },
    startSearch() {
      this.fetchData();
    },


    clearSearchText() {
      this.$store.commit('updateClientSearchText', null);
    },

    setSearchText(payload) {
      this.$store.commit('updateBlackListSearchText', payload.target.value);
    },
    resetPagination() {
      this.$store.commit('updateBlackListPaginationStart', 0);
    },

    nextPage() {
      const currentStep = this.blackListPaginationStart + this.blackListSize;
      this.$store.commit('updateBlackListPaginationStart', currentStep);
      this.fetchData();
    },
    previousPage() {
      const currentStep = this.blackListPaginationStart - this.blackListSize;
      this.$store.commit('updateBlackListPaginationStart', currentStep);
      this.fetchData();
    },
    updateBlackListIsLoading(active) {
      this.$store.commit('updateBlackListIsLoading', active);
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      velocity(el, {opacity: 1}, {duration: 500, complete: done});
    },
    leave(el, done) {
      velocity(el, {opacity: 0}, {duration: 500, complete: done});
    }
  },
  mounted() {
    this.fetchData();
  },
};
</script>
